<button class="btn btn-green btn-full-width margin-top-large">+ Add Template</button>

<div class="table-container">
  <table *ngIf="this.templates.length > 0">
    <thead>
      <tr>
        <th>Template</th>
        <th># Drills</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let t of templates">
        <td>{{ t.label }}</td>
        <td>{{ t.template_drills?.length }}</td>
      </tr>
    </tbody>
  </table>
</div>